import Vue from 'vue'
import App from './App'
import 'moment/locale/zh-cn' // 导入中文语言包，具体路径根据实际需要调整
// import router from './router'
import echarts from 'echarts'
import './utils/ant-design-vue'
window.echart = echarts
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
import 'echarts-liquidfill'

// import { getUrlParam } from '@/utils/fns'
import { getWindowParam } from '@/utils/fns'

// Vue.prototype.GLOBALWS = `ws://192.168.83.36:8098/jpaas-jdata-server/webSocket/`
// Vue.prototype.GLOBALWS = `ws://${location.host}/jpaas-jdata-server/webSocket/`
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')

// const jdataConfig = window.jdataConfig
if (window.jdataParams) {
  if (getWindowParam('id').indexOf('-') !== -1) {
    const idArr = getWindowParam('id').split('|')
    let ele = ''
    let arr = []
    console.log('idArr: ', idArr)
    idArr.forEach(element => {
      ele = element.split('-')
      const obj = {}
      obj.name = ele[0]
      obj.id = ele[1]
      arr.push(obj)
    })
    console.log('ele: ', arr)
    arr.forEach(config => {
      new Vue({
        render: h => h(App),
        data() {
          return {
            jcms_name: config.name,
            jcms_id: config.id,
            jcms_arr: arr
          }
        }
      }).$mount('#' + config.name)
    })
  } else {
    new Vue({
      render: h => h(App),
      data() {
        return {}
      }
    }).$mount('#jdata')
  }
} else {
  new Vue({
    render: h => h(App),
    data() {
      return {}
    }
  }).$mount('#jdata')
}
// if (getUrlParam('id').indexOf('-') !== -1) {
//   const idArr = getUrlParam('id').split('|')
//   let ele = ''
//   let arr = []
//   console.log('idArr: ', idArr)
//   idArr.forEach(element => {
//     ele = element.split('-')
//     const obj = {}
//     obj.name = ele[0]
//     obj.id = ele[1]
//     arr.push(obj)
//   })
//   console.log('ele: ', arr)

//   arr.forEach(config => {
//     new Vue({
//       render: h => h(App),
//       data() {
//         return {
//           jcms_name: config.name,
//           jcms_id: config.id,
//           jcms_arr: arr
//         }
//       }
//     }).$mount('#' + config.name)
//   })
// } else {
//   new Vue({
//     render: h => h(App),
//     data() {
//       return {}
//     }
//   }).$mount('#jdata')
// }
